module.exports = __webpack_public_path__ + "static/4-f7ed30de9b85eec1a8cda983bc5d9617.png";